'use client'

import { useRef, MouseEvent } from 'react'
import PopinPortal from '@/lib/react/PopinPortal'
import { ChevronLeft, ChevronRight, X } from 'lucide-react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

interface VideoPopinProps {
	isOpen: boolean
	closeAction: () => void
	currentSlide: number
	slides: any[]
}

export default function VideoPopin({ isOpen, closeAction, currentSlide, slides }: VideoPopinProps) {
    const overlay = useRef(null)
    
	if (!isOpen) return null
    
	const handleClose = (e: MouseEvent) => {
		if (e.target === overlay.current) {
			closeAction()
		}
	}

	return (
		<PopinPortal>
			<div ref={overlay} onClick={handleClose} className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
				<div className="relative w-full max-w-[800px] shadow-lg p-4 bg-white rounded-sm">
                    <button onClick={closeAction} className="absolute top-0 right-0 z-10 bg-primary-700 hover:bg-primary-800 rounded-full p-2 text-white hover:text-gray-300 md:translate-x-1/2 -translate-y-1/2 cursor-pointer">
                        <X />
                    </button>
					<div className="absolute bottom-6 right-4 w-[100px] h-[50px]">
						<div className="relative w-full h-full">
							<div className="hero-modal-button-prev block absolute top-1/2 left-0 -translate-y-1/2 z-10 cursor-pointer">
								<ChevronLeft className="w-12 h-12 text-primary" />
							</div>
							<div className="hero-modal-button-next block absolute top-1/2 right-0 -translate-y-1/2 z-10 cursor-pointer">
								<ChevronRight className="w-12 h-12 text-primary" />
							</div>
						</div>
					</div>
					<Swiper
						modules={[Pagination, Navigation]}
						spaceBetween={30}
						slidesPerView={1}
						navigation={{
							nextEl: '.hero-modal-button-next',
							prevEl: '.hero-modal-button-prev',
						}}
						className="w-full"
						loop={true}
						initialSlide={currentSlide}
					>
						{slides.map((slide, index) => (
							<SwiperSlide key={index}>
							<div className="flex flex-col">
								<div className="relative">
									<iframe className='w-full aspect-video' src={`${ slide.videoLink }`} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
								</div>
								<div className="flex flex-col gap-4 pt-6 pb-2 pr-24">
									<h2 className="text-2xl font-bold font-alt mb-2">
										{ slide.title }
									</h2>
									<p className='text-sm text-gray-500 font-alt'>
										{ slide.description }
									</p>
								</div>
							</div>
							</SwiperSlide>
						))}
					</Swiper>
				</div>
			</div>
		</PopinPortal>
	)
}
